import { useAppDispatch } from './useAppDispatch'
import { useLazyGetConfigQuery } from '../store/apis/config.api'
import { useCallback, useEffect } from 'react'
import { setConfig } from '../store/slices/portal.slice'

export const useInitConfig = () => {
  const dispatch = useAppDispatch()
  const [getConfigQuery] = useLazyGetConfigQuery()

  const fetchConfig = useCallback(async () => {
    const config = await getConfigQuery()
      .unwrap()
      .catch(() => ({}))

    dispatch(setConfig({ config }))
  }, [getConfigQuery, dispatch])

  useEffect(() => {
    void fetchConfig()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run only once
  }, [])
}
